<template>
  <button class="moin-inputbar_btn" :class="[variant]">
    <slot />
  </button>
</template>

<script setup lang="ts">
const { variant } = defineProps<{
  variant: "soft" | "ghost" | "solid";
}>();
</script>

<style lang="scss">
.moin-inputbar_btn {
  padding: 8px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  align-items: center;
  border-radius: 4px;
  background: transparent;
  border: none;
  // TODO THEME
  color: black;
  font-size: 1.6rem;
  opacity: 1;
  @include default-focus;

  &.labelled {
    padding: 8px 12px;
  }

  &:hover,
  &:focus {
    cursor: pointer;
    opacity: 1;
    background-color: var(--moin-inputbutton-background, #ededed);
  }

  &.ghost {
    background-color: transparent;
    color: var(--moin-inputbutton-textcolor, black);

    &:hover:not(:disabled),
    &:focus {
      cursor: pointer;
      opacity: 1;
      background-color: var(--moin-inputbutton-background, #ededed);
    }
  }

  &.soft {
    color: var(--moin-inputbutton-textcolor, black);
    background-color: var(--moin-inputbutton-background, #ededed);
  }

  &.solid {
    color: var(--moin-inputbutton-textcolor, black);
    background-color: var(--moin-inputbutton-background, white);
    border: 1px solid var(--moin-widget-button-bordercolor);

    &:hover:not(:disabled),
    &:focus {
      cursor: pointer;
      opacity: 1;
      border: 1px solid black;
    }
  }

  &:disabled {
    cursor: not-allowed;
    color: #000000a6;

    svg {
      opacity: 0.65 !important;
    }
  }
}
</style>
